export default "__VITE_ASSET__CME5Hej2__"